// extracted by mini-css-extract-plugin
module.exports = {"promoBadge":"styles_promoBadge__ER3Gt","promoTag":"styles_promoTag___2Xgf"};